import { Routes } from '@angular/router';
import { ItemsComponent } from './items/items.component';

export const TSECTORIAL_ROUTES: Routes = [
    { path: ':id', component: ItemsComponent },
    { path: '**', redirectTo: '/tendencia-sectorial/1' }
];